
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { BaseLayout } from '@/components/templates';
import { withUrql } from '@/config/graphql';
import { Box, Container, Flex, Heading, LinkBox, LinkOverlay, List, ListItem, Text, UnorderedList, } from '@chakra-ui/react';
import { GetServerSideProps, NextPage } from 'next';
import NextLink from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import { filterPageData, getResults } from '@/components/features/search/search.helpers';
import { PageSearchProps } from '@/components/features/search/search.types';
import { Breadcrumbs, LazyImage } from '@meritcircle/ui/components';
import { useContext, useEffect, useState } from 'react';
import { MetaDataContext } from '@/components/contexts/meta-data/meta-data.context';
import { useRouter } from 'next/router';
import { Seo } from '@/components/utils/seo/seo-component';
const Page: NextPage = ({ searchResults = [] }: PageSearchProps) => {
    const { t } = useTranslation('search');
    const { location } = useContext(MetaDataContext);
    const [results, setResults] = useState(searchResults);
    const hasQuery = !!location?.query?.search;
    const hasResults = !!results.length;
    const router = useRouter();
    const canonicalUrl = (process.env.SITE_URL + router.asPath).split('?')[0];
    useEffect(() => {
        const setUniqueResults = async () => {
            const allResults = await getResults(location.query.search);
            setResults(filterPageData(allResults));
        };
        setUniqueResults();
    }, [location.query.search, searchResults]);
    return (<BaseLayout>
      <Seo canonical={canonicalUrl} title={t('meta.title')} description={t('meta.description')}/>
      <Container pb="2xl">
        <Heading size="h1" mt={{ base: 'lg', md: '4xl' }} mb="2xl" variant="glowing">
          {hasQuery ? `${t('title')} ‘${location.query.search}’ (${results.length})` : t('noQuery')}
        </Heading>

        {hasQuery &&
            (hasResults ? (<List spacing="3xl">
              {results.map(result => (<ListItem key={result.fullPath}>
                  <LinkBox>
                    <Flex flexDirection={{ base: 'column-reverse', md: 'row' }}>
                      <Box flexBasis={{ md: '70%' }}>
                        <Box pr={{ md: '3xl' }}>
                          <Breadcrumbs breadcrumbs={[
                        {
                            title: t('title', undefined, {
                                ns: result.translationNamespace
                            }),
                            href: result.rootPath
                        },
                        { title: result.title, href: result.fullPath },
                    ]} mb="md"/>
                          <NextLink href={result.fullPath} passHref legacyBehavior>
                            <LinkOverlay>
                              <Heading as="h3" size="md" mb="md" noOfLines={1}>
                                {result.title}
                              </Heading>
                            </LinkOverlay>
                          </NextLink>
                          <Text noOfLines={2} variant="muted">
                            {result.description}
                          </Text>
                        </Box>
                      </Box>
                      {!!result.image && (<Box mb={{ base: 'md', md: '0' }} flexBasis={{ md: '30%' }}>
                          <LazyImage alt={result.image.title || result.title} src={result.image.url} objectFit="cover" w="100%"/>
                        </Box>)}
                    </Flex>
                  </LinkBox>
                </ListItem>))}
            </List>) : (<Box>
              <Text variant="muted">{`‘${location.query.search}’ ${t('noResults')}`}</Text>
              <Text variant="muted" mt="lg">
                {t('noResultsSuggestions.title')}
              </Text>
              <UnorderedList color="desiredDawn">
                {t('noResultsSuggestions.suggestions')
                    .split(',')
                    .map((suggestion, index) => (<ListItem key={index} sx={{ '::marker': { color: 'lightPurple' } }}>
                      {suggestion}
                    </ListItem>))}
              </UnorderedList>
            </Box>))}
      </Container>
    </BaseLayout>);
};
const getServerSideProps: GetServerSideProps<PageSearchProps> = async ({ query }) => {
    const { search } = query;
    if (!search)
        return {
            props: {}
        };
    const uniqueResults = await getResults(search);
    return {
        props: {
            searchResults: filterPageData(uniqueResults)
        }
    };
};
export default withUrql(Page);

    async function __Next_Translate__getServerSideProps__1973b3b2d0d__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/search/index',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1973b3b2d0d__ as getServerSideProps }
  